export default "__VITE_ASSET__DEDsffzu__"